// MSAL for this app's own registration ('Higgins Measure to Quote'), set up by
// createMsalApp in @higgins/utils (shared config, API scope, token getter,
// sign-out). Startup is startMsalApp and the header's account is
// useMsalAccount, both in @higgins/ui.
import { PublicClientApplication } from '@azure/msal-browser';
import { createMsalApp, onlineOnly } from '@higgins/utils';

const msalApp = createMsalApp((config) => new PublicClientApplication(config), {
  clientId: import.meta.env.VITE_AZURE_CLIENT_ID as string,
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID as string,
});

export const { msalInstance, API_SCOPES, signOut } = msalApp;

/** Offline, never asks (no redirect away from the app); sync retries when signal is back. */
export const getAccessToken = onlineOnly(msalApp.getAccessToken);
